import { call, select, put } from "redux-saga/effects";
import API from "../../API";
import {
  addWordsError,
  addWordsSuccess, closeAddWordsModal,
  eraseAddwordsInputs,
  getTaxonomyListError,
  getTaxonomyListSuccess, wrongValidation
} from "./add-words-action-creators";
import { addNotificationRequest } from "../notifications/notifications-action-creators";

export function* taxonomyListRequest() {
  try {
    const data = yield call(API.getTaxonomyList, localStorage.token);
    console.log(data, "TAXONOMY LIST");
    const taxonomyList = data.data;
    taxonomyList.length
      ? yield put(getTaxonomyListSuccess(data.data))
      : yield put(getTaxonomyListError("Empty taxonomy list"));
  } catch (error) {
    console.log(error, "ERROR FROM TAXONOMY LIST REQUEST");
    yield put(getTaxonomyListError("Something went wrong..."));
  }
}

export function* addWordsRequest() {
  const token = yield select(state => state.login.token);
  const taxonomy = yield select(state => state.addWords.selectedTaxonomy);
  const textAreaWordsProcessed = yield select(state => state.addWords.textAreaWordsProcessed);
  const comment = yield select(state => state.addWords.comment);
  const label = yield select(state => state.selectLabel.selectedLabelColor);
  const terms = textAreaWordsProcessed.map(term => {
    const newObject = {};
    newObject.term = term;
    newObject.comment = comment;
    newObject.label = label;
    return newObject;
  });
  try {
    const data = yield call(API.addWords, { taxonomy, terms, token });
    console.log(data, "DATA FROM ADD WORDS REQUEST");
    const insertedWords = data.data.inserted.map(word => word.term.term).join(", ");
    const existedWords = data.data.existed.map(word => word.term.term).join(", ");
    const messages = [
      `Inserted: ${insertedWords.length ? insertedWords : 'none'} in ${taxonomy}`,
      `Existed: ${existedWords.length ? existedWords : 'none'} in ${taxonomy}`
    ];
    yield put(addNotificationRequest({ message: messages, status: 'Success'}));
    yield put(addWordsSuccess());
    yield put(closeAddWordsModal())

  } catch (error) {
    console.log(error, "ERROR FROM ADD WORDS REQUEST");
    yield put(addWordsError());
    yield put(addNotificationRequest({ message: ["Something went wrong"], status: "Error"}));
  }
}



// WEBPACK FOOTER //
// ./src/modules/add-words/add-words-saga.js